

import { useState, useEffect } from 'react'
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import ButtonAction from "/src/components/UI/Button/Button";
import { useForm, useFieldArray } from "react-hook-form";
import botService from "/src/features/bot/services/botService"
import phoneService from '../../services/phoneService';
import companyService from "/src/features/administration/company/services/companyService"
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import Dropdown from '../../../../../components/UI/DropDown/DropDown';
import languages from '/src/data/dropdown/languages';
import channelService from '/src/features/plugins/channels/services/channelService';
import CheckBox from '/src/components/UI/CheckBox/CheckBox';

import AutoComplete from "/src/components/UI/AutoComplete/AutoComplete";
import "./PhoneModalBody.css";
import Storage from '/src/utils/storage';
import { statusPhone} from '../../data/statusPhones';
function PhoneModalBody({ form }) {

    const storage = Storage('local');
    const { is_admin } = storage.get('user');
    const [phoneAvailable, setPhoneAvailable] = useState({ numbers: true });
    const company = form.company;
    const channel = form.channel;
    const data = {
        phone_id: form.id ?? null,
        ...form,
        company_id: form.company?.id ?? form.company_id ?? null,
        channel_id: form.channel?.id ?? form.channel_id ?? null,
        country: form.country ?? { alpha_code_2: "fr" },
        max_simultaneous_call: form.max_simultaneous_call ?? 1,
        is_mutu: form.is_mutu ?? false,
        status: form.status ?? "free",
        in: form.in ?? false,
        out: form.out ?? false,
        telephony_partner: form.telephony_partner ?? null,
        number_owner: form.number_owner ?? null,
        contact_reference: form.contact_reference ?? null,
    };


    const { register, setError, clearErrors, watch, handleSubmit, control, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            country: data.country.alpha_code_2.toLowerCase(),
            numbers: data.numbers,
            is_mutu: data.is_mutu,
            company_id: data.company_id,
            max_simultaneous_call: data.max_simultaneous_call,
            libelle: data.libelle,
            channel_id: data.channel_id,
            telephony_partner: data.telephony_partner,
            number_owner: data.number_owner,
            contact_reference: data.contact_reference,
            status: data.status,
            in: data.in,
            out: data.out,
        }
    });
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    const { addPhone, updatePhone, checkPhoneAvailability } = phoneService;
    const { getCompaniesAutocomplete } = companyService;
    const { getChannelsAutocomplete } = channelService;

    const onSubmit = async () => {
        var dataToSend = getValues();

        // A RAJOUTER PLUS TARD LE OWNER
        /*
        if (data.phone_id != undefined) {     // mean we are in update form since we have data
            dataToSend.country = dataToSend.country.alpha_code_2
        }
        */
        let [response, error] = data.phone_id ? await updatePhone(data.phone_id, dataToSend) : await addPhone(dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }

        modal.resolve(response)
        onClose();
        return;

    };

    const checkValues = async (title, value) => {
        let dataToSend = [];
        value = value.replace(/\s+/g, '');
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkPhoneAvailability(dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = phoneAvailable;
        res[title] = response.available
        if (data != null && value === data[title]) {
            res[title] = true
        }

        setPhoneAvailable({ ...res })
    }

    return (
        <div>
            <Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>{form.title}</Form.Title>
                <Form.Body className="body-editModal-container">
                    <div style={{ marginTop: "25px", display: "flex", marginBottom: "25px" }}>
                        <Field label="Country Code"></Field>
                        <div style={{ marginLeft: "15%", marginTop: "2%" }}>
                            <Dropdown {...register('country')} setValue={setValue} choices={languages} defaultChoice={data.country ? data.country.alpha_code_2.toLowerCase() : "fr"} width="165px"></Dropdown>
                        </div>
                    </div>
                    <div style={{ display: "block", paddingBottom: "8px", marginBottom: "8px" }}>
                        <div className="champs_phone_modal">
                            <Field label={<span> Number <span className="obligatory_field">*</span> </span>} />
                            <TextInput {...register('numbers', { required: true, minLength: 10, onChange: (e) => checkValues("numbers", e.target.value) })} style={errors.numbers || phoneAvailable.numbers == false ? { borderColor: "red" } : {}} className="full-width input_user_ModalBody" defaultValue={data ? data.numbers : ""} placeholder="Enter a phone number" disabled={data.is_mutu} />
                        </div>
                        <div className="champs_phone_modal">
                            <Field label={<span> Amount of call simultaneous <span className="obligatory_field">*</span> </span>} />
                            <TextInput {...register('max_simultaneous_call', { required: true })} style={errors.numbers ? { borderColor: "red" } : {}} className="full-width input_user_ModalBody" defaultValue={data ? data.max_simultaneous_call : "1"} placeholder="Enter your amount of call simultaneous" />
                        </div>

                        <div className="champs_phone_modal">
                            <Field label="Telephony Partner" />
                            <TextInput {...register('telephony_partner')} className="full-width input_user_ModalBody" />
                        </div>

                        <div className="champs_phone_modal">
                            <Field label="Number Owner" />
                            <TextInput {...register('number_owner')} className="full-width input_user_ModalBody" />
                        </div>

                        <div className="champs_phone_modal">
                            <Field label="Contact Reference" />
                            <TextInput {...register('contact_reference')} className="full-width input_user_ModalBody" />
                        </div>
                        <div className="champs_phone_modal">
                            <div style={{ marginTop: "40px", marginBottom: '25px', display: "flex", gap: '4rem' }}>
                                <Field label="Status" listLabelClassName="titles-input" />
                                <div style={{ marginLeft: "5%", marginTop: "2%" }}>
                                    <Dropdown  {...register('status')} setValue={setValue} choices={statusPhone} defaultChoice={data.status ?? "free"} width="300px" ></Dropdown>
                                </div>
                            </div>
                        </div>
                        <div className='grid-row' style={{ display: 'flex' }}>
                            <Field label="In :" listClassName="labels_form_phones" />
                            <div className='dropdown_container'>
                                <CheckBox name="in" checked={watch('in')} onChange={(e) => setValue('in', e.target.checked)} />
                            </div>
                        </div>

                        <div className='grid-row' style={{ display: 'flex' }}>
                            <Field label="Out :" listClassName="labels_form_phones" />
                            <div className='dropdown_container'>
                                <CheckBox name="out" checked={watch('out')} onChange={(e) => setValue('out', e.target.checked)} />
                            </div>
                        </div>

                        <div className="champs_phone_modal">
                            <Field label={<span> Description <span className="obligatory_field">*</span></span>} />
                            <TextInput {...register('libelle', { required: true, minLength: 3 })} style={errors.libelle ? { borderColor: "red" } : {}} className="full-width input_user_ModalBody" defaultValue={data ? data.libelle : ""} placeholder="Enter a libelle" />
                            </div>
                    </div>

                    {data.is_mutu == false ?
                        <div className="champs_phone_modal" style={{ display: is_admin ? 'block' : 'none' }}>
                            <Field label={"Organization"} />
                            <AutoComplete name="company_id" value={company?.name} className="full-width input_user_ModalBody" getItemValue={(name, item) => setValue(name, item.id)} apiCall={getCompaniesAutocomplete} getImageFromItem={(item) => item.logo} placeholder="Choose your organization"></AutoComplete>
                        </div> : null}

                    {
                        watch("company_id") != null && Number.isInteger(watch("company_id")) ?
                            <div className="champs_phone_modal">
                                <Field label="Channel Name" />
                                <AutoComplete name="channel_id" value={channel?.name} className="full-width input_user_ModalBody" getItemValue={(name, item) => setValue(name, item.id)} apiCall={getChannelsAutocomplete} paramsApi={{ company: getValues("company_id") }} getImageFromItem={(item) => item.company_logo} placeholder="Choose your channel"></AutoComplete>
                            </div>
                            :
                            null
                    }




                </Form.Body>
                <Form.Buttons>
                    <ButtonAction type="submit" label={data.phone_id ? "Update" : "Add"}
                        disabled={!formState.isValid || phoneAvailable.numbers == false} onSubmit={onSubmit}></ButtonAction>
                </Form.Buttons>
            </Form>
        </div>

    );
}
export default PhoneModalBody;